import { COMPOSE_ONLY_ATTACHMENT_CLASS_NAME } from 'owa-attachment-link-common';
import { BEAUTIFUL_LINK_COMPOSE_ONLY_ATTRIBUTE_NAME } from 'owa-compose-link';

export function removeComposeOnlyContent(root: HTMLElement) {
    const tempNodes = root.querySelectorAll(`.${COMPOSE_ONLY_ATTACHMENT_CLASS_NAME}`);
    for (let i = 0; i < tempNodes.length; i++) {
        tempNodes[i].parentNode?.removeChild(tempNodes[i]);
    }

    const attrNodes = root.querySelectorAll(`[${BEAUTIFUL_LINK_COMPOSE_ONLY_ATTRIBUTE_NAME}]`);
    for (let i = 0; i < attrNodes.length; i++) {
        attrNodes[i].removeAttribute(BEAUTIFUL_LINK_COMPOSE_ONLY_ATTRIBUTE_NAME);
    }
}
